<div class="layout-container">
    @if(loaderIcon | async){
    <app-loader></app-loader>
    }
    @if(VId == 0){
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    }
    <div [ngClass]="VId == 0 ? 'main-content' : ''">
        @if(VId == 0){
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        }
        <div [ngClass]="VId == 0 ? 'content-area' : ''">
            @if(VId == 0){
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="fw-semibold">{{'Create New Vendor' | wordReplace}}</h5>
            </div>
            <hr />
            }
            <div class="row">
                <div class="col-lg-7 mb-4" [formGroup]="vendorForm">
                    <div class="card shadow p-3">
                        <h5 class="mb-3 pb-2"> @if(VId == 0){ {{'Add New Vendor Info' | wordReplace}} }@else{ {{'Modify
                            Vendor Info' | wordReplace}} }</h5>
                        <div class="row g-3">
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">{{'Vendor ID' | wordReplace}}</label>
                                <span class="text-danger">*</span>
                                <input type="text" #marketVendorId formControlName="marketVendorId" [maxlength]="9"
                                    (input)="allowOnlyAlphaNumericVendorId($event)" class="form-control"
                                    (blur)="checkVendorIdExists()">
                                @if (vendorForm.get('marketVendorId').invalid) {
                                <small style="color: red;" i18n>* required</small>
                                }
                            </div>
                        </div>
                        <div class="row g-3">
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">First Name</label>
                                <span class="text-danger" *ngIf="isMandatory('firstName')">*</span>
                                <input type="text" #firstName formControlName="firstName" class="form-control"
                                    maxlength="50">
                                @if (vendorForm.get('firstName').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('firstName').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4"
                                *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Middle Name')">
                                <label class="form-label">Middle Name</label>
                                <span class="text-danger" *ngIf="isMandatory('middleName')">*</span>
                                <input type="text" formControlName="middleName" class="form-control" maxlength="50">
                                @if (vendorForm.get('middleName').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('middleName').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4"
                                *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Last Name')">
                                <label class="form-label">Last Name</label>
                                <span class="text-danger" *ngIf="isMandatory('lastName')">*</span>
                                <input type="text" formControlName="lastName" class="form-control" maxlength="50">
                                @if (vendorForm.get('lastName').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('lastName').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-5">
                                <label class="form-label">Company Name</label>
                                <span class="text-danger" *ngIf="isMandatory('companyName')">*</span>
                                <input type="text" formControlName="companyName" class="form-control" maxlength="50">
                                @if (vendorForm.get('companyName').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('companyName').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">Address</label>
                                <span class="text-danger" *ngIf="isMandatory('address')">*</span>
                                <input type="text" formControlName="address" class="form-control" maxlength="80">
                                @if (vendorForm.get('address').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('address').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <label class="form-label" style="visibility: hidden;">Address</label>
                                <input type="text" formControlName="address2" class="form-control" maxlength="80">
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">City</label>
                                <span class="text-danger" *ngIf="isMandatory('city')">*</span>
                                <input type="text" formControlName="city" (blur)="UpdateVendorAddressValidation()"
                                    class="form-control" maxlength="30">
                                @if (vendorForm.get('city').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('city').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <!-- <div class="col-md-6 col-lg-3">
                                <label class="form-label">State</label>
                                <span class="text-danger" *ngIf="isMandatory('state')">*</span>
                                <select class="form-select" (blur)="UpdateVendorAddressValidation()"
                                    formControlName="state">
                                    @for (ct of StateList; track $index) {
                                    <option [value]="ct.StateCode">
                                        {{ct.StateName}}
                                    </option>
                                    }
                                </select>
                                @if (vendorForm.get('state').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                            </div> -->

                            <div class="col-md-6 col-lg-3">
                                <label class="form-label">
                                    State
                                    <span class="text-danger" *ngIf="isMandatory('state')">*</span>
                                </label>

                                <!-- Dropdown when states are available -->
                                <select *ngIf="StateList.length > 0" class="form-select"
                                    (blur)="UpdateVendorAddressValidation()" formControlName="state">

                                    <option value="" disabled>Select</option>

                                    @for (ct of StateList; track $index) {
                                    <option [value]="ct.StateCode">
                                        {{ ct.StateName }}
                                    </option>
                                    }
                                </select>

                                <!-- Text input when no states are available -->
                                <input *ngIf="StateList.length === 0" type="text" class="form-control"
                                    formControlName="state" placeholder="Enter State" maxlength="20"
                                    (blur)="UpdateVendorAddressValidation()" />

                                @if (vendorForm.get('state').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <label class="form-label">Zip / Postal Code</label>
                                <span class="text-danger" *ngIf="isMandatory('zipCode')">*</span>
                                <!-- <input type="text" class="form-control" (blur)="UpdateVendorAddressValidation()" formControlName="zipCode">

                                        @if (vendorForm.get('zipCode').hasError('required')) {
                                        <small style="color: red;" i18n>* required</small>
                                        }
                                        @if (vendorForm.get('zipCode').hasError('maxlength')) {
                                        <small style="color: red;" i18n>*required</small>
                                        } -->
                                @if (showZipCodeAsNumber) {
                                <input type="text" class="form-control" id="txtCompantZipCode" formControlName="zipCode"
                                    (blur)="formatUSZipCode();UpdateVendorAddressValidation();UpdateStateAndCityByZipcode()"
                                    maxlength="10">
                                }
                                @if (!showZipCodeAsNumber) {
                                <input type="text" class="form-control" formControlName="zipCode"
                                    (blur)="UpdateVendorAddressValidation();UpdateStateAndCityByZipcode()"
                                    maxlength="10">
                                }
                                @if (vendorForm.get('zipCode').hasError('maxlength')) {
                                <small style="color: red;" i18n>* max length exceeded </small>
                                }
                                @if (vendorForm.get('zipCode').hasError('required')) {
                                <small style="color: red;" i18n>* required </small>
                                }
                                @if (vendorForm.get('zipCode').hasError('invalidZipCode')) {
                                <div class=" alert-danger">
                                    @if (vendorForm.get('countryCode').value == 1) {
                                    Invalid Zip code. Format: 12345 or 12345-6789.
                                    }
                                    @else if (vendorForm.get('countryCode').value == 2) {
                                    Invalid postal code. Format: A1A 1A1.
                                    }
                                    @else {
                                    Invalid Zip code.
                                    }
                                </div>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">Country</label>
                                <select class="form-select" formControlName="countryCode" #country
                                    (change)="onCountryChange()">
                                    @for (ct of CountryList; track $index) {
                                    <option [value]="ct.Code">
                                        {{ct.Name}}
                                    </option>
                                    }
                                </select>
                                @if (vendorForm.get('country').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">Email</label>
                                <span class="text-danger" *ngIf="isMandatory('email')">*</span>
                                <input type="email" class="form-control" formControlName="email" maxlength="100">
                                @if (vendorForm.get('email').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('email').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">Type</label>
                                <span class="text-danger">*</span>
                                <select id="ddlType" class="form-select" formControlName="vendorType">
                                    @for (ct of VendorTypeList; track $index) {
                                    <option [value]="ct.VtyTxtVendorTypeValue">
                                        {{ct.VtyTxtVendorType}}
                                    </option>
                                    }
                                </select>

                                <!-- @if (vendorForm.get('vendorType').hasError('required')) {
                                        <small style="color: red;" i18n>* required</small>
                                        } -->
                            </div>

                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">Cell Phone</label>
                                <span class="text-danger" *ngIf="isMandatory('cellPhone')">*</span>
                                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="cellPhone" id="cellPhone"
                                    formControlName="cellPhone"></ejs-maskedtextbox>
                                @if (vendorForm.get('cellPhone').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('cellPhone').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">Telephone</label>
                                <span class="text-danger" *ngIf="isMandatory('telephone')">*</span>
                                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="telephone" id="telephone"
                                    formControlName="telephone"></ejs-maskedtextbox>
                                @if (vendorForm.get('telephone').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('telephone').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">Work Phone</label>
                                <span class="text-danger" *ngIf="isMandatory('workPhone')">*</span>
                                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="WorkPhone" id="WorkPhone"
                                    formControlName="workPhone"></ejs-maskedtextbox>
                                @if (vendorForm.get('workPhone').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('workPhone').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4 mt-3">
                                <label class="form-label">Driver License#</label>
                                <span class="text-danger" *ngIf="isMandatory('driverLicense')">*</span>
                                <input type="text" class="form-control" formControlName="driverLicense">
                                @if (vendorForm.get('driverLicense').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('driverLicense').hasError('maxlength')) {
                                <small style="color: red;" i18n> * max length exceeded</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4 mt-3">
                                <label class="form-label">DL Expiry Date</label>
                                <span class="text-danger" *ngIf="isMandatory('DLexpiryDate')">*</span>
                                <ejs-datepicker class="form-control p-0" formControlName="DLexpiryDate"
                                    placeholder="MM/DD/YYYY"></ejs-datepicker>
                                @if (vendorForm.get('DLexpiryDate').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('DLexpiryDate').hasError('maxlength')) {
                                <small style="color: red;" i18n>*required</small>
                                }
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="form-label">{{'Vendor Since' | wordReplace}}</label>
                                <span class="text-danger" *ngIf="isMandatory('vendorSince')">*</span>
                                <ejs-datepicker #VendorSinceDate class="form-control p-0" formControlName="vendorSince"
                                    (blur)="validateVendorSinceDate(VendorSinceDate.value)" placeholder="MM/DD/YYYY"
                                    [max]="maxDate"></ejs-datepicker>
                                @if (vendorForm.get('vendorSince').hasError('required')) {
                                <small style="color: red;" i18n>* required</small>
                                }
                                @if (vendorForm.get('vendorSince').hasError('maxlength')) {
                                <small style="color: red;" i18n>*required</small>
                                }
                            </div>
                        </div>

                    </div>
                    <div class="card shadow p-3 mt-2">
                        <h5 class="mb-3">Social Media Networking</h5>
                        <div class="row g-4">
                            <div class="col-md-6">
                                <label class="form-label">Facebook ID</label>
                                <span class="text-danger" *ngIf="isMandatory('facebookID')">*</span>
                                <div class="input-group">
                                    <span class="input-group-text text-white" style="background-color: #106FBE">
                                        <i class="fab fa-facebook-f text-white"></i>
                                    </span>
                                    <input type="text" class="form-control" formControlName="facebookID" maxlength="40">
                                    @if (vendorForm.get('facebookID').hasError('required')) {
                                    <small style="color: red;" i18n>* required</small>
                                    }
                                    @if (vendorForm.get('facebookID').hasError('maxlength')) {
                                    <small style="color: red;" i18n> * max length exceeded</small>
                                    }
                                </div>
                            </div>
                            <!-- <div class="col-md-6">
                                            <label class="form-label">X (Twitter)</label>
                                            <div class="input-group">
                                                <span class="input-group-text" style="width:40px; height:40px; justify-content:center;">
                                                    <img [src]="'assets/images/icons8-x-twitter.svg'" 
                                                        alt="Twitter" 
                                                        style="max-width:24px; max-height:32px;">
                                                </span>
                                                <input type="text" class="form-control" formControlName="twitter">
                                                @if (vendorForm.get('twitter').hasError('required')) {
                                                    <small style="color: red;"  i18n>* required</small>
                                                }
                                                @if (vendorForm.get('twitter').hasError('maxlength')) {
                                                <small style="color: red;"  i18n>*required</small>
                                                }
                                            </div>
                                        </div> -->
                            <div class="col-md-6">
                                <label class="form-label">LinkedIn ID</label>
                                <span class="text-danger" *ngIf="isMandatory('linkedinID')">*</span>
                                <div class="input-group">
                                    <span class="input-group-text bg-primary text-white"
                                        style="background-color: #0082CA;">
                                        <i class="fab fa-linkedin-in text-white"></i>
                                    </span>
                                    <input type="text" class="form-control" formControlName="linkedinID" maxlength="40">
                                    @if (vendorForm.get('linkedinID').hasError('required')) {
                                    <small style="color: red;" i18n>* required</small>
                                    }
                                    @if (vendorForm.get('linkedinID').hasError('maxlength')) {
                                    <small style="color: red;" i18n> * max length exceeded</small>
                                    }
                                </div>
                            </div>
                            <!-- <div class="col-md-6">
                                            <label class="form-label">Instagram ID</label>
                                            <div class="input-group">
                                                <span class="input-group-text text-white"
                                                    style="background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);">
                                                    <i class="fab fa-instagram text-white"></i>
                                                </span>
                                                <input type="text" class="form-control" formControlName="instagramID">
                                                @if (vendorForm.get('instagramID').hasError('required')) {
                                                    <small style="color: red;"  i18n>* required</small>
                                                }
                                                @if (vendorForm.get('instagramID').hasError('maxlength')) {
                                                <small style="color: red;"  i18n>*required</small>
                                                }
                                            </div>
                                        </div> -->

                        </div>
                    </div>
                </div>
                <div class="col-lg-5 mb-4">
                    <div class="card shadow p-3">
                        <h5 class="mb-3">@if(VId == 0){ Add }@else{ Update } {{'Vendor Photo' | wordReplace}}</h5>
                        <span class="text-danger" *ngIf="isMandatory('vendorProfile')">*</span>
                        <div class="d-flex align-items-center">
                            <div class="logo-box mx-auto position-relative" style="margin-left: 0px !important;">
                                <div class="w-100 h-100 d-flex align-items-center justify-content-center p-1">
                                    <img [src]="this.vendorForm.get('vendorProfile').value == '' || this.vendorForm.get('vendorProfile').value == null  ? './assets/images/NoPhoto.svg' : this.vendorForm.get('vendorProfile').value"
                                        alt="Vendor Logo" id="logoPreview" class="img-fluid"
                                        style="pointer-events: none;">
                                </div>
                            </div>
                            <div>
                                <label class="btn btnAS mb-2">
                                    ADD
                                    <!-- <input type="file" hidden accept="image/*" (change)="onLogoSelected($event)"> -->
                                    <input id="fileVendorPhoto" hidden type="file" (change)="VendorPhotoUpload($event)"
                                        accept="image/*" />
                                </label><br />
                                <button class="btn btnAS mb-2" (click)="removeVendorPhoto()">REMOVE</button><br>

                            </div>
                        </div>
                    </div>
                    <div class="card shadow p-3 mt-2">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <h5 class="mb-0">{{'Vendor Products' | wordReplace}}</h5>
                            <!-- <button class="btn btnAS" (click)="openvendorProductForm(NewVendorProduct)" >ADD</button> -->
                            <button class="btn btnAS" (click)="openModal()">ADD</button>
                        </div>
                        <ejs-grid #GridVenProd [dataSource]='VendorProductsList' height="200px">
                            <e-columns>
                                <e-column field="ProductName" headerText="Product" width="150"></e-column>
                                <e-column field="ProductCategory" headerText="Category" width="110"></e-column>
                                <e-column field="Priority" headerText="Primary" width="80">
                                    <ng-template #template let-data>
                                        <input class="form-check-input" type="checkbox" id="primary"
                                            [checked]="data.Priority" (change)="ChangePriority(data,$event)">
                                    </ng-template>
                                </e-column>
                                <e-column field="Delete" headerText="" width="50">
                                    <ng-template #template let-data>
                                        <i class="fa fa-trash" (click)="deleteVendorProduct($event,data)"></i>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>

                    </div>

                    <div class="card shadow p-3 mt-2" [formGroup]="vendorForm">
                        <h5 class="fw-semibold mb-3">Settings</h5>
                        <div class="row mb-2 align-items-center">
                            <div class="col-md-7 d-flex align-items-center">
                                <input class="form-check-input me-2" type="checkbox" id="AutoDeductRent"
                                    formControlName="AutoDeductRent">
                                <label class="form-check-label me-auto" for="AutoDeductRent">Auto Deduct Rent</label>
                            </div>

                        </div>

                        <div class="row mb-2 align-items-center">
                            <div class="col-md-7 d-flex align-items-center">
                                <input class="form-check-input me-2" type="checkbox" id="flatCommission"
                                    (change)="ToggleFlatComm()" formControlName="ApplyFlatCommissionPos">
                                <label class="form-check-label me-auto" for="flatCommission">Apply Flat Commission on
                                    POS (%)</label>
                            </div>
                            <div class="col-md-3">
                                <input type="text" class="form-control" formControlName="FlatCommissionPos"
                                    appPercentageFormatter>
                            </div>
                        </div>

                        <div class="row align-items-center">
                            <div class="col-md-7 d-flex align-items-center">
                                <input class="form-check-input me-2" type="checkbox" id="rdConsignmentCommission"
                                    (change)="ToggleConsComm()" formControlName="EnableConsignmentCommission">
                                <label class="form-check-label me-auto" for="rdConsignmentCommission">Consignment
                                    Commission (%)</label>
                            </div>
                            <div class="col-md-3">
                                <input type="text" class="form-control" formControlName="ConsignmentCommission"
                                    appPercentageFormatter>
                            </div>
                        </div>
                    </div>

                    <div class="mt-2 text-lg-end">
                        <ejs-tooltip id='tooltipbtnNewCard' target="#targetNewCard" position='LeftCenter'
                            (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btnAS me-1" [userPermissionHandler]="createOrEditPermissionHandler"
                                (click)="UpdateVendor($event)">Save</button>
                        </ejs-tooltip>
                        <button class="btn btn-orange" (click)="CancelUpdate()">Cancel</button>
                    </div>
                </div>
            </div>


            <!-- Modal -->
            <div class="modal-backdrop" *ngIf="showModal">
                <div class="modal-content" (click)="$event.stopPropagation()">
                    <form [formGroup]="vendorProductForm">
                        <div class="modal-header">
                            <h4 class="modal-title font-weight-normal">{{'Vendor product' | wordReplace}}</h4>
                        </div>

                        <div class="modal-body ptb24">
                            <!-- Product -->
                            <div class="row mx-0 mt-3">
                                <div class="col-4">
                                    <label for="product">Product *</label>
                                </div>
                                <div class="col-8">
                                    <select id="product" formControlName="productId" class="form-select"
                                        (change)="productchanged($event)">
                                        <option value="">Select Product</option>
                                        <option *ngFor="let product of filteredProductList" [value]="product.ProductId">
                                            {{ product.ProductName }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Category -->
                            <div class="row mx-0 mt-3">
                                <div class="col-4">
                                    <label for="Category">Category *</label>
                                </div>
                                <div class="col-8">
                                    <select id="Category" formControlName="productCategoryId" class="form-select"
                                        (change)="onCategoryChange($event)">
                                        <option value="">Select Category</option>
                                        <option *ngFor="let cate of categoriesList" [value]="cate.ProductCategoryId">
                                            {{ cate.ProductCategory }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Priority -->
                            <div class="row mx-0 mt-3">
                                <div class="col-4">
                                    <label for="Priority">Primary</label>
                                </div>
                                <div class="col-8">
                                    <label class="pure-material-checkbox mb-0 without-text">
                                        <input type="checkbox" class="form-check-input" formControlName="priority" id="Priority">
                                        <span></span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-orange" style="margin-right: 15px;"
                                (click)="onModalClosed()">Cancel</button>
                            <button type="button" class="btn btnAS me-1"
                                (click)="SaveVendorProduct($event)">Save</button>
                        </div>
                    </form>
                </div>
            </div>